import { FunctionComponent, useState } from "react";
import classNames from "classnames";
import { ChevronDownIcon } from "@heroicons/react/outline";


interface Props {
    children: React.ReactNode;
    title: string;
}

const SimpleAccordion: FunctionComponent<Props> = ({title, children}) => {
 const [open, setOpen] = useState(false);

 return (
   <div className="w-full border-t border-gray-300">
     <button
       type="button"
       className="w-full flex items-center justify-between px-2 py-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
       onClick={() => setOpen(!open)}
     >
       <span className="text-gray-800">{title}</span>
       <ChevronDownIcon
         height={18}
         width={18}
         className={classNames(
           "text-gray-500 flex-shrink-0 ml-4 transition-transform duration-300",
           { "rotate-180": open }
         )}
       />
     </button>
     <div
       className={classNames(
         "overflow-hidden transition-all duration-300 ease-in-out",
         open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
       )}
     >
       <div className="px-2 pb-4">
         {children}
       </div>
     </div>
   </div>
 );
};


export { SimpleAccordion };
